import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { getSeparatedPhone } from 'legacy/lut/components/widgets/public/phoneEditor/helpers/getSeparatedPhone'

const PHONE_FIELDS = [
  { number: 'WorkPhone', prefix: 'WorkPhone_Prefix' },
  { number: 'MobilePhone', prefix: 'MobilePhone_Prefix' },
] as const

/**
 * Ensures a contact's phones are stored as separate country code + local number
 * before the contact is sent to `contact:update`.
 *
 * Mirrors the normalization the contact edit dialog performs on open: when the
 * prefix is empty but the number holds a full (possibly `00`-prefixed) string,
 * the number is split into code + body. An existing prefix is only stripped of
 * leading zeros. Paths that save the contact without opening the edit dialog
 * (e.g. assigning the L&R Champion role) would otherwise send the whole number
 * in a single field with no country code.
 */
export const splitContactPhones = (contact: DataModel): void => {
  PHONE_FIELDS.forEach(({ number, prefix }) => {
    const code = (contact.get(prefix) || '').replace(/^0*/, '')
    const phone = contact.get(number) || ''

    if (code) {
      contact.set(prefix, code)
      return
    }

    if (!phone) {
      return
    }

    const separated = getSeparatedPhone({ phone })
    contact.set(prefix, separated.code)
    contact.set(number, separated.phone)
  })
}
